import React from 'react';
import { Card, CardContent, Typography, Divider, Box } from '@mui/material';
import { FaCalendar } from "react-icons/fa";

import { FaLocationDot } from "react-icons/fa6";
import { IoTimeOutline } from "react-icons/io5";

const EventCard = ({ event }) => {
  return (
    <Card variant="outlined" sx={{ maxWidth: 400, margin: "1rem auto" }}>
      <CardContent>
        {/* Event Name */}
        <Typography variant="h6" fontWeight="bold" color="primary" gutterBottom>
          {event.name}
        </Typography>

        {/* Date and Time */}
        <Box display="flex" alignItems="center" mb={1}>
          <FaCalendar  style={{marginLeft: 6, marginRight: 6}} />
          <Typography variant="body2" color="textSecondary">
            { new Date(event.time).toLocaleDateString()} 
          </Typography>
        </Box>
        
        <Box display="flex" alignItems="center" mb={1}>
          <IoTimeOutline  style={{marginLeft: 6, marginRight: 6}} />
          <Typography variant="body2" color="textSecondary">
            {new Date(event.time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </Typography>
        </Box>

        {/* Venue and Address */}
        <Divider sx={{ my: 1 }} />
        
        <Box display="flex" alignItems="center" mb={1}>
          <FaLocationDot style={{marginLeft: 6, marginRight: 6}} />
          <Box>
            <Typography variant="body2" color="textSecondary"><strong>Venue:</strong> {event.venue}</Typography>
            <Typography variant="body2" color="textSecondary"><strong>Address:</strong> {event.address}</Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default EventCard;
